import apiClient from './apiClient';

const authService = {
  // Login de usuario
  loginUser: async (email, password) => {
    try {
      const response = await apiClient.post('/users/login', { email, password });
      
      // Guardar token y datos del usuario en memoria (no localStorage)
      if (response.data.token) {
        // Guardar en variables globales o estado de la aplicación
        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('user', JSON.stringify(response.data.user));
      }
      
      return response.data;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      throw error;
    }
  },

  // Verificar email de usuario
  verifyUserEmail: async (email) => {
    try {
      const response = await apiClient.get(`/users/verifyUserEmail?email=${email}`);
      return response.data;
    } catch (error) {
      console.error('Error al verificar email:', error);
      throw error;
    }
  },

  // Logout
  logout: () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  },

  // Obtener token actual
  getToken: () => {
    return sessionStorage.getItem('token');
  },

  // Obtener usuario actual
  getCurrentUser: () => {
    const user = sessionStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Verificar si está autenticado
  isAuthenticated: () => {
    return !!sessionStorage.getItem('token');
  },

  // Verificar rol del usuario
  hasRole: (role) => {
    const user = authService.getCurrentUser();
    return user && user.role === role;
  }
};

export default authService;